import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@app/components/button/button.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalEditLifemapEntryComponent } from './modalEditLifemapEntry.component';
import { EditLifemapEntryModule } from '@app/components/blocks/block-lifemap/editLifemapEntry/editLifemapEntry.module';

@NgModule({
  imports: [ButtonModule, CommonModule, MatDialogModule, PlIconModule, TranslateModule, EditLifemapEntryModule],
  declarations: [ModalEditLifemapEntryComponent],
  exports: [ModalEditLifemapEntryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalEditLifemapEntryModule {}
